import type { TransportMode } from '../../../../../models/transport-mode.enum';
import TransportModeIcon from '../TransportModeIcon';
import { TransportSubModeHelper } from '../../../../../helpers/transport-sub-mode.helper';

function TransportSubModeCheckbox({
  transportMode,
  transportSubMode,
  checked,
  className,
  isInvalid = false,
  onChange,
}: {
  transportMode: TransportMode;
  transportSubMode: string; // type is string to support special case 'otherTrain'
  checked: boolean;
  className?: string;
  isInvalid?: boolean;
  onChange: (transportSubMode: string, checked: boolean) => void;
}) {
  function handleChange() {
    onChange(transportSubMode, !checked);
  }

  return (
    <div className={`transport-mode-checkbox form-check ${className}`}>
      <input id={transportSubMode} type="checkbox" className={`form-check-input ${isInvalid ? 'is-invalid' : ''}`} aria-invalid={isInvalid} checked={checked} onChange={handleChange} />
      <label htmlFor={transportSubMode} className="form-check-label fw-normal d-flex align-items-center text-nowrap">
        <TransportModeIcon className="transport-mode-checkbox__icon me-1" transportMode={transportMode} overrideAltText="" renderAsSquare={true} />
        {TransportSubModeHelper.translate(transportSubMode)}
      </label>
    </div>
  );
}

export default TransportSubModeCheckbox;
